// src/helper/appointmentConstants.js

export const LOCATION_MODE = {
  GOOGLE_MAPS: "GOOGLE_MAPS",
  MANUAL: "MANUAL",
  SAVED_ADDRESSES: "SAVED_ADDRESSES",
};

// --------------------
// Appointment Payment Status Enum
// --------------------
export const APPOINTMENT_PAYMENT_STATUS = Object.freeze({
  PENDING: 0,
  INITIATED: 1,
  COMPLETE: 2,
  FAILED: 3,
  SPONSORED: 4,
  // LINK_NOT_GENERATED: 5, //removed - no use
  LINK_EXPIRED: 6,
  LINK_CANCELLED: 7,
  REFUNDED: 8, // old 7
});

// --------------------
// Payment Status List (Response Shape Unchanged)
// --------------------
export const getAppointmentPaymentStatusList = () => {
  return [
    {
      id: APPOINTMENT_PAYMENT_STATUS.PENDING,
      key: "APPOINTMENT_PAYMENT_STATUS_PENDING",
      label: "Link pending",
    },
    {
      id: APPOINTMENT_PAYMENT_STATUS.INITIATED,
      key: "APPOINTMENT_PAYMENT_STATUS_INITIATED",
      label: "Link requested",
    },
    {
      id: APPOINTMENT_PAYMENT_STATUS.FAILED,
      key: "APPOINTMENT_PAYMENT_STATUS_FAILED",
      label: "Link failed",
    },
    {
      id: APPOINTMENT_PAYMENT_STATUS.COMPLETE,
      key: "APPOINTMENT_PAYMENT_STATUS_COMPLETE",
      label: "Paid",
    },
    {
      id: APPOINTMENT_PAYMENT_STATUS.SPONSORED,
      key: "APPOINTMENT_PAYMENT_STATUS_SPONSORED",
      label: "Sponsored",
    },
    // {
    //   id: APPOINTMENT_PAYMENT_STATUS.LINK_NOT_GENERATED,
    //   key: "APPOINTMENT_PAYMENT_STATUS_LINK_NOT_GENERATED",
    //   label: "Link Not Generated",
    // },
    // {
    //   id: APPOINTMENT_PAYMENT_STATUS.LINK_EXPIRED,
    //   key: "APPOINTMENT_PAYMENT_STATUS_LINK_EXPIRED",
    //   label: "Link Expired",
    // },
    // {
    //   id: APPOINTMENT_PAYMENT_STATUS.LINK_CANCELLED,
    //   key: "APPOINTMENT_PAYMENT_STATUS_LINK_CANCELLED",
    //   label: "Link Cancelled",
    // },
    {
      id: APPOINTMENT_PAYMENT_STATUS.REFUNDED,
      key: "APPOINTMENT_PAYMENT_STATUS_REFUNDED",
      label: "Refunded",
    },
  ];
};
